// Web shim for isomorphic-dompurify - uses native DOMPurify without jsdom
const DOMPurify = require('dompurify');
module.exports = DOMPurify.default || DOMPurify;
